<template>
    <div class="page page-home" v-if="privacyData.paragraph">
        <div id="scrollItem"
             :class="['pageContent', themeText()]">
            <div class="paragraph">
                <div class="contentWrap"
                     v-html="privacyData.paragraph.content">
                </div>
                <div class="title">{{ privacyData.paragraph.title }}</div>
                <div v-for="(item,index) in privacyData.paragraph.list"
                     :key="index">
                    <div class="title">{{ item.title }}</div>
                    <div class="contentWrap"
                         v-html="item.content">
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
/**
 * 第三方信息共享清单
 * */
import {  getTheme } from '@/utils/index';
import setStateBarColor from '@/utils/setStateBarColor';
export default {
data(){
  return {
      privacyData: {}
  }
},
methods:{
    getThemeFn(){
      getTheme()
    },
     themeText() {
      return this.getThemeFn() ? 'dark' : 'light'
    },
    setStateBarColor(){
      if(this.getThemeFn()) {
             setStateBarColor(1, 'FAFAFA');
       }else {
           setStateBarColor(1, '050505');
       }
    },
},
mounted(){
  document.documentElement.scrollTop = 0; //置顶
  this.setStateBarColor();
  this.privacyData = require(`@/utils/tpls.json`).shareList;
}
}

</script>

<style lang="stylus" scoped>
@import '@/style/var.styl';

.page {
    * {
        box-sizing: border-box;
    }
}

.page-home {
    font-size: 0.16rem;
    overflow: scroll;

    .pageContent {
        overflow: scroll;
        position: relative;
        padding:0rem 0.16rem 0 0.16rem;
        .header{
          margin-bottom: 0.32rem;    
        }
        .paragraph {
            margin-bottom: 0.32rem;
        }
        /deep/.contentWrap{
            p{
                font-size:0.14rem;
                line-height: 0.21rem;
                margin-bottom: 0.32rem
                word-break: break-all;
            } 
        }
    }
    .tableWrap {
        width: auto;
        overflow: auto;
        display: flex;
        flex-direction: row;

        * {
            box-sizing: border-box;
        }

        .spaceWrap {
            border-left: .16rem solid transparent;
        }
    }
    .table {
        overflow-x: scroll;
        position: relative;
        border-collapse: collapse;
        border-spacing: 0;

        .titleWrap {
            font-size: 0.12rem;
            line-height: 0.16rem;
            display: flex;
            flex-direction: row;
            overflow: hidden;

            th {
                height: 0.4rem;
                width: 1.16rem;
                display: flex;
                flex: 1;
                padding: 0.12rem 0.16rem;
                align-items: center;
                text-align: left;
                // border-top: 0;
                border-right: 0;
                border-bottom: 0;
            }
        }

        .dataLine {
            font-size: 0.12rem;
            display: flex;
            flex-direction: row;

            td {
                width: 1.16rem;
                display: flex;
                flex: 1;
                padding: 0.16rem;
                line-height: 0.16rem;
                align-items: center;
                text-align: center;
                z-index: 1;
                word-wrap: break-word;
                word-break: break-all;
                text-align: left;
                border-bottom: 0;
                border-right: 0;
            }
        }

        .tableLine {
            position: absolute;
            height: 100%;
            top: 0;
        }
    }
    .dark {
        background: #050505;
        .time {
            color: rgba(255, 255, 255, 0.55);
        }
        .title{
                color: rgba(255, 255, 255, 0.85);
        }
        /deep/.contentWrap{
            p{
               color: rgba(255, 255, 255, 0.55);
            } 
        }
        .content{
            color: rgba(255, 255, 255, 0.55);
        }
        .titleWrap {
            color: rgba(255, 255, 255, 0.85);
        }
        th {
             background: rgba(255, 255, 255,0.06);
            border: 0.0033rem solid rgba(255, 255, 255, 0.1);
        }
        td {
           background: #000000;
           border: 0.0033rem solid rgba(255, 255, 255, 0.1);
        }
        .dataLine{
            color: rgba(0, 0, 0, 0.55);
        }
        .columns {
            color: rgba(255, 255, 255, 0.55);
        }
        table tr td:last-child {
          border-right: 0.0033rem solid rgba(255, 255, 255,0.1) !important;
        }
        table tr:first-child th:last-child {
          border-right: 0.0033rem solid rgba(255, 255, 255,0.1) !important;
        }
        table tr:last-child td {
            border-bottom: 0.0033rem solid rgba(255, 255, 255,0.1) !important;
        }
     }

    .light {
        background: #FAFAFA;
        .time {
           color: rgba(0, 0, 0, 0.55);
        }
        .title{
             color: rgba(0, 0, 0, 0.85)
        }
        /deep/.contentWrap{
            p{
               color: rgba(0, 0, 0, 0.55);
            } 
        }
        .content{
            color: rgba(0, 0, 0, 0.55);
        }
        .titleWrap {
            color: rgba(0, 0, 0, 0.85);
        }
        th {
            background: rgba(0, 0, 0, 0.06);
            border: 0.0033rem solid rgba(0, 0, 0, 0.1);
        }
       td {
           background: #ffffff;
           border: 0.0033rem solid rgba(0, 0, 0, 0.1);
        }
       .dataLine{
            color: rgba(255, 255, 255, 0.55);
        }
        .columns {
            color: rgba(0, 0, 0, 0.55);
        }
        table tr td:last-child {
          border-right: 0.0033rem solid rgba(0,0,0,0.1) !important;
        }
        table tr:first-child th:last-child {
          border-right: 0.0033rem solid rgba(0,0,0,0.1) !important;
        }
        table tr:last-child td {
            border-bottom: 0.0033rem solid rgba(0,0,0,0.1) !important;
        }
    }
}
</style>
